import React from "react";
import { Route } from "react-router-dom";
import { UserRoleEnum } from "@/types/role.type";
import type { RouteCtx } from "../routeContext";
import {
  MonitoringTracker,
  VisitDetailsPage,
  MonitoringOversightDashboard,
} from "../lazyPages";

/** Shared / multi-role monitoring aliases. */
export function sharedMonitoringRoutes(ctx: RouteCtx): React.ReactNode {
  const { userRole, currentStudy } = ctx;

  const allowed =
    userRole === UserRoleEnum.TENANT ||
    userRole === UserRoleEnum.CRA ||
    userRole === UserRoleEnum.DATA_MANAGER ||
    userRole === UserRoleEnum.SPONSOR ||
    userRole === UserRoleEnum.PROJECT_MANAGER ||
    userRole === UserRoleEnum.PRINCIPAL_INVESTIGATOR;

  if (!allowed) {
    return null;
  }

  return (
    <>
      <Route
        path="/monitor-tracker"
        element={
          <MonitoringTracker userRole={userRole} currentStudy={currentStudy} />
        }
      />
      <Route
        path="/admin/monitoring-tracker"
        element={
          <MonitoringTracker userRole={userRole} currentStudy={currentStudy} />
        }
      />
      <Route
        path="/monitoring-visits"
        element={
          <MonitoringTracker userRole={userRole} currentStudy={currentStudy} />
        }
      />
      <Route
        path="/monitoring-visits/:visitId"
        element={<VisitDetailsPage />}
      />
      <Route
        path="/admin/monitoring-tracker/:visitId"
        element={<VisitDetailsPage />}
      />
      <Route
        path="/sponsor/ctms/monitoring"
        element={
          <MonitoringTracker userRole={userRole} currentStudy={currentStudy} />
        }
      />
      <Route
        path="/sponsor/ctms/oversight"
        element={<MonitoringOversightDashboard currentStudy={currentStudy} />}
      />
    </>
  );
}
